import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { TrackedNavLink } from 'src/shared/design-system/TrackedNavLink';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Colors, FontFamily, FontSize, FontWeight, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const NAV_BAR_MOBILE_SPACING = Spacing.SINGLE;
export const NAV_BAR_SPACING = Spacing.SINGLE_QUARTER;

export const CONSUMER_HEADER_HEIGHT = 50;
export const NavBar = styled.nav<{ isFixed: boolean }>`
  height: ${CONSUMER_HEADER_HEIGHT}px;
  background-color: ${Colors.WHITE};
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid ${Colors.GRAY_LITE_20};

  padding-left: ${Spacing.SINGLE};
  padding-right: ${Spacing.SINGLE};
  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: 0 ${Spacing.HALF};
  }

  ${ifProp(
    'isFixed',
    css`
      position: fixed;
      width: 100%;
      z-index: 25;
    `
  )}
`;

export const NavItemLink = styled(TrackedNavLink)`
  color: ${Colors.GRAY_DARK_20};
  font-weight: ${FontWeight.BOLD};
  font-size: ${FontSize.S};
  font-family: ${FontFamily.BODY_SANS};

  &:hover,
  &:focus {
    color: ${Colors.GRAY_DARK_20};
    text-decoration: none;
  }
`;

export const NavItemLinkContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  flex-shrink: 0;
`;

export const NavItemLinkBottomBorder = styled.div<{ color: Colors }>`
  height: 3px;
  background-color: ${({ color }) => color};
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const SignUpButton = styled(PrimaryButton)`
  font-weight: ${FontWeight.MEDIUM};
  border-radius: 30px;
  font-size: ${FontSize.XXS};
  padding: ${Spacing.QUARTER} ${Spacing.SINGLE};
  line-height: ${Spacing.NONE};
  flex-shrink: 0;
`;
